import { CultureInfo } from '../culture-info.model';
import { CultureInfoKs } from './ks';

/**
 * @ignore
 */
export const CultureInfoKsArab: CultureInfo = {
  name: 'ks-Arab',
  displayName: 'Kashmiri (Naskh)',
  iso3LanguageCode: 'kas',
  iso2LanguageCode: 'ks',
  ietfLanguageTag: 'ks-Arab',
  parent: CultureInfoKs
};
